export default function IconA2() {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1215_7352)">
                <path
                    d="M28.6875 5.625H7.3125C6.38052 5.625 5.625 6.38052 5.625 7.3125V27.5625C5.625 28.4945 6.38052 29.25 7.3125 29.25H28.6875C29.6195 29.25 30.375 28.4945 30.375 27.5625V7.3125C30.375 6.38052 29.6195 5.625 28.6875 5.625Z"
                    stroke="#707070"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.5 9H5.625V13.5H11.8125C12.7445 13.5 13.5 12.7445 13.5 11.8125V9Z"
                    stroke="#707070"
                    strokeWidth="1.35"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M13.5 29.25H9V30.375H13.5V29.25Z" stroke="#707070" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M27 29.25H22.5V30.375H27V29.25Z" stroke="#707070" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M5.625 9H30.375" stroke="#707070" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1215_7352">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
